import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface ShowSelectionState {
  selectedShowId: string | null;
}

const LOCAL_STORAGE_KEY = "selectedShowId";

const initialState: ShowSelectionState = {
  selectedShowId: localStorage.getItem(LOCAL_STORAGE_KEY) || null,
};

const showSelectionSlice = createSlice({
  name: "showSelection",
  initialState,
  reducers: {
    setSelectedShowId(state, action: PayloadAction<string | null>) {
      state.selectedShowId = action.payload;
      if (action.payload && action.payload !== "-1") {
        localStorage.setItem(LOCAL_STORAGE_KEY, action.payload);
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
      }
    },
  },
});

export const { setSelectedShowId } = showSelectionSlice.actions;
export default showSelectionSlice.reducer;

export const showSelectionApi = createApi({
  reducerPath: "showSelectionApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/" }), // not used (local only)
  tagTypes: ["ShowSelection"],
  endpoints: (builder) => ({
    getSelectedShowId: builder.query<string | null, void>({
      queryFn: () => {
        const val = localStorage.getItem(LOCAL_STORAGE_KEY);
        return { data: val || null };
      },
      providesTags: ["ShowSelection"],
    }),
    setSelectedShowId: builder.mutation<string | null, string | null>({
      queryFn: (value) => {
        if (value && value !== "-1") {
          localStorage.setItem(LOCAL_STORAGE_KEY, value);
        } else {
          localStorage.removeItem(LOCAL_STORAGE_KEY);
          value = null;
        }
        return { data: value };
      },
      invalidatesTags: ["ShowSelection"],
    }),
  }),
});

export const {
  useGetSelectedShowIdQuery,
  useSetSelectedShowIdMutation,
} = showSelectionApi;